export default __webpack_public_path__ + "static/Avenir-Light-07-ead92412a10cb86ca91a012dc03b6a29.ttf";